import React from "react";

const IconSchoolBag = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1284_8003)">
      <path
        d="M2.89844 6.87158H4.55704V24.9634H2.89844V6.87158Z"
        fill="url(#paint0_linear_1284_8003)"
      />
      <path
        d="M4.55752 25.7588H3.02272C2.74915 25.7588 2.52734 25.5371 2.52734 25.2634V24.5823C2.52734 24.3087 2.74915 24.0869 3.02272 24.0869H4.55752V25.7588Z"
        fill="url(#paint1_linear_1284_8003)"
      />
      <path
        d="M9.5799 14.5897H4.11311L2.91838 7.30571C2.85388 6.9059 2.94737 6.49706 3.17689 6.16338C3.87323 5.15111 4.69745 4.23334 5.62608 3.4334C6.44509 2.72789 7.72076 3.19296 7.89306 4.26007L9.5799 14.5897Z"
        fill="url(#paint2_linear_1284_8003)"
      />
      <path
        d="M9.57875 14.5898L7.89191 4.2601C7.84736 3.98433 7.72877 3.74916 7.56375 3.56363C7.18772 3.50527 6.78402 3.59927 6.45423 3.88331C5.5256 4.68325 4.70138 5.60102 4.00504 6.61329C3.77552 6.94697 3.68196 7.35582 3.74653 7.75563L4.86747 14.5898H9.57875Z"
        fill="url(#paint3_linear_1284_8003)"
      />
      <path
        d="M27.4414 6.87158H29.1V24.9634H27.4414V6.87158Z"
        fill="url(#paint4_linear_1284_8003)"
      />
      <path
        d="M27.4414 9.58545V24.9633H29.1V11.2441L27.4414 9.58545Z"
        fill="url(#paint5_linear_1284_8003)"
      />
      <path
        d="M27.4414 25.7588H28.9762C29.2498 25.7588 29.4716 25.5371 29.4716 25.2634V24.5823C29.4716 24.3087 29.2498 24.0869 28.9762 24.0869H27.4414V25.7588Z"
        fill="url(#paint6_linear_1284_8003)"
      />
      <path
        d="M22.4219 14.5897H27.8887L29.0834 7.30571C29.1479 6.9059 29.0544 6.49706 28.8249 6.16338C28.1285 5.15111 27.3043 4.23334 26.3757 3.4334C25.5567 2.72789 24.281 3.19296 24.1087 4.26007L22.4219 14.5897Z"
        fill="url(#paint7_linear_1284_8003)"
      />
      <path
        d="M27.8875 14.5898L29.0822 7.3058C29.1467 6.90599 29.0532 6.49714 28.8237 6.16346C28.5433 5.75593 28.2413 5.36459 27.9211 4.98925C27.6123 4.66844 27.2889 4.36161 26.9513 4.07085C26.1323 3.36535 24.8566 3.83041 24.6843 4.89752L23.1016 14.5898H27.8875Z"
        fill="url(#paint8_linear_1284_8003)"
      />
      <path
        d="M24.7031 14.5898H27.8873L28.5298 10.6722L24.7031 6.84546V14.5898Z"
        fill="url(#paint9_linear_1284_8003)"
      />
      <path
        d="M19.7341 7.46855H12.2656V3.73421C12.2656 1.67517 13.9407 0 15.9998 0C18.0589 0 19.7341 1.67517 19.7341 3.73421V7.46855ZM14.1401 5.59404H17.8595V3.73427C17.8595 2.70877 17.0253 1.87457 15.9998 1.87457C14.9743 1.87457 14.1401 2.70883 14.1401 3.73427V5.59404Z"
        fill="url(#paint10_radial_1284_8003)"
      />
      <path
        d="M25.2762 31.0798C19.1535 32.3067 12.8483 32.3067 6.72568 31.0798C5.15429 30.7649 4.02344 29.3849 4.02344 27.7824V15.0744C4.02344 8.45943 9.38595 3.09692 16.001 3.09692C22.6159 3.09692 27.9785 8.45943 27.9785 15.0744V27.7824C27.9785 29.385 26.8476 30.7649 25.2762 31.0798Z"
        fill="url(#paint11_linear_1284_8003)"
      />
      <path
        d="M17.4932 4.59009C10.8781 4.59009 5.51562 9.9526 5.51562 16.5676V29.2756C5.51562 29.8155 5.64444 30.3299 5.87472 30.787C6.13868 30.9198 6.42348 31.0195 6.72466 31.0799C12.8473 32.3067 19.1525 32.3067 25.2751 31.0799C26.8465 30.765 27.9774 29.385 27.9774 27.7824V15.0744C27.9774 12.1471 26.9266 9.46551 25.1825 7.38494C23.102 5.64082 20.4205 4.59009 17.4932 4.59009Z"
        fill="url(#paint12_linear_1284_8003)"
      />
      <path
        d="M21.9883 4.69873C23.2533 6.67865 23.9868 9.03109 23.9868 11.5549V25.084C23.9868 26.7901 22.7828 28.2593 21.1099 28.5945C15.5638 29.7058 9.87714 29.8709 4.28906 29.0911C4.71203 30.0912 5.60715 30.8557 6.72608 31.0799C12.8488 32.3068 19.1539 32.3068 25.2765 31.0799C26.8479 30.7651 27.9788 29.3851 27.9788 27.7825V15.0745C27.9789 10.6405 25.5693 6.76944 21.9883 4.69873Z"
        fill="url(#paint13_linear_1284_8003)"
      />
      <path
        d="M25.2746 31.0799C26.846 30.765 27.9768 29.385 27.9768 27.7824V21.1813L25.7565 18.9609C25.2724 18.4402 24.6009 18.0996 23.8577 18.0383C18.6178 17.6061 13.3809 17.6061 8.14089 18.0383C6.86064 18.1439 5.79221 19.0772 5.53044 20.3348C5.06801 22.5562 5.06795 24.7315 5.53044 26.9533C5.65555 27.5545 5.96533 28.0812 6.39406 28.4791L9.45904 31.5441C14.7129 32.2791 20.0599 32.1248 25.2746 31.0799Z"
        fill="url(#paint14_linear_1284_8003)"
      />
      <path
        d="M4.02344 27.0112V27.7824C4.02344 29.3851 5.15429 30.765 6.72568 31.0799C12.8483 32.3067 19.1535 32.3067 25.2761 31.0799C26.8475 30.765 27.9784 29.385 27.9784 27.7824V27.0112H4.02344Z"
        fill="url(#paint15_linear_1284_8003)"
      />
      <path
        d="M6.13728 22.7829C6.08426 22.6805 5.97853 22.6096 5.85517 22.6096C5.67911 22.6096 5.53637 22.7524 5.53637 22.9284V22.9624C5.07074 23.1 4.73047 23.5305 4.73047 24.0405V25.8865C4.73047 26.2316 4.88658 26.5404 5.1316 26.7467L10.0011 31.6162C11.3128 31.7843 12.6298 31.897 13.9487 31.9544V31.0093C13.9487 30.6989 13.8227 30.4176 13.6188 30.2145L6.13728 22.7829Z"
        fill="url(#paint16_linear_1284_8003)"
      />
      <path
        d="M23.8578 29.2499C18.6178 29.6821 13.381 29.6821 8.14093 29.2499C6.86068 29.1443 5.79225 28.2109 5.53042 26.9533C5.06792 24.7315 5.06805 22.5562 5.53042 20.3348C5.79219 19.0772 6.86068 18.1438 8.14086 18.0383C13.3809 17.6061 18.6177 17.6061 23.8577 18.0383C25.1379 18.1439 26.2064 19.0772 26.4681 20.3348C26.9306 22.5562 26.9306 24.7315 26.4681 26.9533C26.2065 28.2109 25.1381 29.1443 23.8578 29.2499Z"
        fill="url(#paint17_linear_1284_8003)"
      />
      <path
        d="M26.4695 20.3346C26.2077 19.077 25.1392 18.1437 23.859 18.0381C23.5539 18.0129 23.2487 17.9895 22.9436 17.9673C23.3687 20.1256 23.3579 22.2428 22.908 24.4038C22.6463 25.6615 21.5778 26.5949 20.2975 26.7004C15.3627 27.1074 10.4306 27.1308 5.49609 26.7712C5.50802 26.8319 5.519 26.8924 5.53161 26.9531C5.79338 28.2107 6.86187 29.1441 8.14212 29.2497C13.3821 29.6819 18.619 29.6819 23.859 29.2497C25.1393 29.1441 26.2078 28.2107 26.4695 26.9531C26.932 24.7313 26.9319 22.556 26.4695 20.3346Z"
        fill="url(#paint18_linear_1284_8003)"
      />
      <path
        d="M23.86 29.2499C25.1402 29.1443 26.2087 28.2109 26.4705 26.9533C26.933 24.7315 26.9329 22.5562 26.4705 20.3348C26.4246 20.1141 26.3533 19.9037 26.2609 19.7057C25.8906 19.4881 25.4693 19.3498 25.0218 19.3129C19.7818 18.8807 14.545 18.8807 9.30495 19.3129C8.0247 19.4185 6.95628 20.3518 6.6945 21.6094C6.23207 23.8309 6.23201 26.0062 6.6945 28.228C6.74043 28.4487 6.81171 28.6591 6.90413 28.8571C7.27439 29.0747 7.69579 29.213 8.14322 29.2499C13.3831 29.6822 18.62 29.6821 23.86 29.2499Z"
        fill="url(#paint19_linear_1284_8003)"
      />
      <path
        d="M5.23763 22.3714C5.20714 22.7481 5.19095 23.1242 5.1875 23.5003C8.45909 23.3262 12.1926 23.2341 16.0014 23.2341C19.8101 23.2341 23.5436 23.3262 26.8152 23.5003C26.8118 23.1242 26.7956 22.7481 26.7651 22.3714C23.5001 22.2 19.7871 22.1094 16.0014 22.1094C12.2157 22.1094 8.50264 22.2 5.23763 22.3714Z"
        fill="url(#paint20_linear_1284_8003)"
      />
      <path
        d="M26.4493 23.2716C26.4438 23.2716 26.4383 23.2715 26.4328 23.2712C26.0648 23.2513 25.6909 23.2325 25.3116 23.2148C25.1461 23.207 25.0182 23.0666 25.026 22.9011C25.0337 22.7357 25.175 22.607 25.3396 22.6155C25.7204 22.6334 26.0957 22.6522 26.4651 22.6722C26.6305 22.6811 26.7574 22.8225 26.7484 22.9879C26.7398 23.1478 26.6074 23.2716 26.4493 23.2716ZM6.95988 23.2021C6.80038 23.2021 6.66774 23.0766 6.66046 22.9157C6.65306 22.7503 6.78118 22.6101 6.94664 22.6026C7.31721 22.586 7.69268 22.5703 8.07248 22.5558C8.23731 22.5488 8.37729 22.6785 8.38363 22.844C8.38997 23.0095 8.2609 23.1489 8.09538 23.1552C7.71696 23.1697 7.34281 23.1852 6.97356 23.2018C6.96898 23.202 6.9644 23.2021 6.95988 23.2021ZM23.8275 23.1519C23.8236 23.1519 23.8198 23.1518 23.816 23.1516C23.4458 23.1376 23.0715 23.1247 22.6937 23.1127C22.5281 23.1074 22.3982 22.9689 22.4034 22.8034C22.4087 22.6378 22.5465 22.5113 22.7127 22.5131C23.0917 22.5251 23.4672 22.5382 23.8386 22.5522C24.0041 22.5584 24.1332 22.6977 24.1269 22.8632C24.1209 23.0249 23.9879 23.1519 23.8275 23.1519ZM9.58256 23.1041C9.42112 23.1041 9.28785 22.9757 9.28296 22.8132C9.27794 22.6477 9.40807 22.5094 9.57365 22.5044C9.94586 22.4931 10.3214 22.4828 10.6998 22.4736C10.8648 22.4678 11.0029 22.6004 11.007 22.7661C11.011 22.9316 10.8801 23.0692 10.7145 23.0733C10.3373 23.0825 9.96292 23.0927 9.59185 23.1039C9.58878 23.104 9.58564 23.1041 9.58256 23.1041ZM21.2047 23.0711C21.2023 23.0711 21.1998 23.0711 21.1974 23.0711C20.8258 23.0622 20.4516 23.0541 20.075 23.047C19.9093 23.044 19.7776 22.9072 19.7807 22.7415C19.7838 22.5759 19.9212 22.443 20.0862 22.4473C20.4639 22.4544 20.8392 22.4624 21.2118 22.4713C21.3774 22.4753 21.5084 22.6128 21.5044 22.7784C21.5005 22.9415 21.367 23.0711 21.2047 23.0711ZM12.2069 23.0421C12.0437 23.0421 11.91 22.9113 11.9071 22.7474C11.9043 22.5817 12.0362 22.4452 12.2019 22.4423C12.5754 22.4358 12.9511 22.4303 13.3285 22.4257H13.3322C13.4962 22.4257 13.6301 22.5576 13.632 22.7221C13.634 22.8877 13.5014 23.0236 13.3357 23.0256C12.9593 23.0301 12.5847 23.0356 12.2121 23.042C12.2105 23.0421 12.2087 23.0421 12.2069 23.0421ZM18.5814 23.0244C18.5802 23.0244 18.5791 23.0244 18.5778 23.0244C18.2051 23.0201 17.8306 23.0167 17.4549 23.0142C17.2893 23.0131 17.1559 22.8779 17.157 22.7124C17.158 22.5467 17.2917 22.4117 17.4588 22.4144C17.8356 22.4169 18.211 22.4203 18.5847 22.4246C18.7504 22.4265 18.8831 22.5623 18.8811 22.728C18.8793 22.8924 18.7454 23.0244 18.5814 23.0244ZM14.8321 23.0126C14.6672 23.0126 14.5332 22.8793 14.5323 22.7143C14.5314 22.5486 14.665 22.4136 14.8306 22.4127C15.2052 22.4107 15.5807 22.4097 15.9572 22.4097C16.1228 22.4097 16.2571 22.5439 16.2571 22.7095C16.2572 22.8752 16.1229 23.0095 15.9573 23.0095C15.5819 23.0096 15.2072 23.0106 14.8338 23.0126C14.8333 23.0126 14.8327 23.0126 14.8321 23.0126Z"
        fill="url(#paint21_linear_1284_8003)"
      />
      <path
        d="M6.13695 22.7829C6.08393 22.6805 5.9782 22.6096 5.85484 22.6096C5.67878 22.6096 5.53604 22.7524 5.53604 22.9284V22.9624C5.41237 22.999 5.29792 23.0567 5.19596 23.1305C5.15436 24.4012 5.26611 25.6695 5.53334 26.9533C5.55204 27.0433 5.57532 27.1312 5.60204 27.2176L7.50993 29.1255C7.71317 29.1893 7.92525 29.2319 8.14379 29.2499C9.73795 29.3815 11.3319 29.4723 12.9257 29.5238L6.13695 22.7829Z"
        fill="url(#paint22_linear_1284_8003)"
      />
      <path
        d="M6.64997 23.2457C6.44674 23.0418 6.16558 22.9158 5.85518 22.9158C5.23431 22.9158 4.73047 23.4196 4.73047 24.0405V25.8865C4.73047 26.5074 5.23438 27.0112 5.85518 27.0112C6.47604 27.0112 6.97988 26.5074 6.97988 25.8865V24.0405C6.97988 23.73 6.85389 23.4489 6.64997 23.2457ZM5.85518 24.6868C5.52376 24.6868 5.25533 24.4184 5.25533 24.087C5.25533 23.7555 5.52376 23.4871 5.85518 23.4871C6.1866 23.4871 6.45502 23.7555 6.45502 24.087C6.45502 24.4184 6.1866 24.6868 5.85518 24.6868Z"
        fill="url(#paint23_linear_1284_8003)"
      />
      <path
        d="M5.85051 23.0374C5.27055 23.0374 4.80078 23.5071 4.80078 24.0871C4.80078 24.667 5.27055 25.1368 5.85051 25.1368C6.43046 25.1368 6.90023 24.667 6.90023 24.0871C6.90023 23.5071 6.43046 23.0374 5.85051 23.0374ZM5.85051 24.6869C5.51909 24.6869 5.25066 24.4185 5.25066 24.0871C5.25066 23.7557 5.51909 23.4872 5.85051 23.4872C6.18193 23.4872 6.45035 23.7557 6.45035 24.0871C6.45035 24.4185 6.18193 24.6869 5.85051 24.6869Z"
        fill="url(#paint24_radial_1284_8003)"
      />
      <path
        d="M5.85397 23.8457C5.6779 23.8457 5.53516 23.703 5.53516 23.5269V22.9284C5.53516 22.7524 5.6779 22.6096 5.85397 22.6096C6.03003 22.6096 6.17277 22.7524 6.17277 22.9284V23.5269C6.17271 23.703 6.03003 23.8457 5.85397 23.8457Z"
        fill="url(#paint25_linear_1284_8003)"
      />
      <path
        d="M21.8699 15.8989H10.1319C9.50894 15.8989 9.00391 15.3939 9.00391 14.771V11.5533C9.00391 10.9303 9.50888 10.4253 10.1319 10.4253H21.8699C22.4928 10.4253 22.9978 10.9303 22.9978 11.5533V14.771C22.9978 15.3939 22.4928 15.8989 21.8699 15.8989Z"
        fill="url(#paint26_linear_1284_8003)"
      />
      <path
        d="M21.6074 15.4238H10.3907C9.84059 15.4238 9.39453 14.9778 9.39453 14.4276V11.8968C9.39453 11.3467 9.84052 10.9006 10.3907 10.9006H21.6074C22.1576 10.9006 22.6036 11.3466 22.6036 11.8968V14.4276C22.6036 14.9778 22.1576 15.4238 21.6074 15.4238Z"
        fill="url(#paint27_linear_1284_8003)"
      />
      <path
        d="M15.9991 12.544C18.254 12.544 20.4817 12.5765 22.6036 12.639V11.8968C22.6036 11.7602 22.576 11.6301 22.5263 11.5115C20.4263 11.4508 18.2257 11.4192 15.9991 11.4192C13.7725 11.4192 11.5718 11.4508 9.4719 11.5115C9.42214 11.63 9.39453 11.7601 9.39453 11.8968V12.639C11.5165 12.5765 13.7441 12.544 15.9991 12.544Z"
        fill="url(#paint28_linear_1284_8003)"
      />
      <path
        d="M14.084 11.6721C14.0828 11.6721 14.0815 11.6721 14.0803 11.6721C13.7028 11.6736 13.3271 11.6761 12.9535 11.6795C12.7878 11.681 12.6548 11.8164 12.6563 11.9821C12.6578 12.146 12.7903 12.2779 12.9536 12.2792H12.9589C13.3315 12.2759 13.7062 12.2735 14.0826 12.272C14.2482 12.2713 14.3819 12.1366 14.3813 11.9709C14.3808 11.8065 14.2479 11.6735 14.084 11.6721Z"
        fill="url(#paint29_linear_1284_8003)"
      />
      <path
        d="M11.4509 11.6988C11.0725 11.705 10.6968 11.7123 10.3245 11.7205C10.1589 11.7241 10.0277 11.8613 10.0313 12.0269C10.0349 12.1894 10.1671 12.3189 10.3285 12.3202C10.3316 12.3202 10.3348 12.3202 10.3378 12.3201C10.709 12.3119 11.0834 12.3048 11.4607 12.2986C11.6263 12.2959 11.7584 12.1595 11.7557 11.9939C11.7529 11.8281 11.6159 11.6943 11.4509 11.6988Z"
        fill="url(#paint30_linear_1284_8003)"
      />
      <path
        d="M16.7086 11.6778C16.3322 11.6748 15.9566 11.6728 15.5821 11.6716C15.4164 11.6712 15.2818 11.8051 15.2813 11.9707C15.2808 12.1358 15.4138 12.2702 15.5787 12.2715H15.5803C15.9538 12.2725 16.3284 12.2746 16.7038 12.2776C16.8695 12.2789 17.0048 12.1457 17.0061 11.98C17.0074 11.8144 16.8743 11.6792 16.7086 11.6778Z"
        fill="url(#paint31_linear_1284_8003)"
      />
      <path
        d="M19.3364 11.7139C18.9626 11.7065 18.5873 11.7 18.2106 11.6944C18.0435 11.6903 17.9087 11.8243 17.9063 11.9899C17.9038 12.1555 18.0361 12.2918 18.2018 12.2942C18.5774 12.2998 18.9518 12.3062 19.3246 12.3136H19.3282C19.4922 12.3149 19.6271 12.184 19.6304 12.0196C19.6335 11.854 19.502 11.7171 19.3364 11.7139Z"
        fill="url(#paint32_linear_1284_8003)"
      />
      <path
        d="M21.9607 11.7824C21.5882 11.7704 21.2129 11.7594 20.8353 11.7492C20.6704 11.7436 20.5319 11.8753 20.5275 12.0409C20.523 12.2065 20.6536 12.3443 20.8192 12.3488C21.1957 12.359 21.5699 12.37 21.9414 12.382C21.9439 12.3821 21.9463 12.3821 21.9487 12.3821C22.1111 12.3834 22.2456 12.2549 22.2508 12.0919C22.2561 11.9263 22.1263 11.7877 21.9607 11.7824Z"
        fill="url(#paint33_linear_1284_8003)"
      />
      <path
        d="M10.231 11.8603C10.178 11.7579 10.0723 11.687 9.94892 11.687C9.77286 11.687 9.63012 11.8298 9.63012 12.0058V12.0398C9.16449 12.1774 8.82422 12.6079 8.82422 13.1178V14.9639C8.82422 15.3091 8.98033 15.6177 9.22535 15.8241L14.0948 20.6936C15.4066 20.8616 16.7236 20.9743 18.0424 21.0318V20.0867C18.0424 19.7763 17.9164 19.4951 17.7125 19.2919L10.231 11.8603Z"
        fill="url(#paint34_linear_1284_8003)"
      />
      <path
        d="M10.7437 12.3231C10.5405 12.1192 10.2593 11.9932 9.94892 11.9932C9.32806 11.9932 8.82422 12.497 8.82422 13.1179V14.9639C8.82422 15.5848 9.32806 16.0886 9.94892 16.0886C10.5698 16.0886 11.0736 15.5848 11.0736 14.9639V13.1179C11.0736 12.8074 10.9476 12.5262 10.7437 12.3231ZM9.94892 13.7642C9.6175 13.7642 9.34908 13.4958 9.34908 13.1644C9.34908 12.8329 9.6175 12.5645 9.94892 12.5645C10.2803 12.5645 10.5488 12.8329 10.5488 13.1644C10.5488 13.4957 10.2803 13.7642 9.94892 13.7642Z"
        fill="url(#paint35_linear_1284_8003)"
      />
      <path
        d="M9.95207 12.1145C9.37211 12.1145 8.90234 12.5842 8.90234 13.1642C8.90234 13.7442 9.37211 14.214 9.95207 14.214C10.532 14.214 11.0018 13.7442 11.0018 13.1642C11.0018 12.5842 10.532 12.1145 9.95207 12.1145ZM9.95207 13.7641C9.62065 13.7641 9.35222 13.4957 9.35222 13.1642C9.35222 12.8328 9.62065 12.5644 9.95207 12.5644C10.2835 12.5644 10.5519 12.8328 10.5519 13.1642C10.5519 13.4956 10.2834 13.7641 9.95207 13.7641Z"
        fill="url(#paint36_radial_1284_8003)"
      />
      <path
        d="M9.95162 12.9232C9.77556 12.9232 9.63281 12.7804 9.63281 12.6043V12.0058C9.63281 11.8298 9.77556 11.687 9.95162 11.687C10.1277 11.687 10.2704 11.8298 10.2704 12.0058V12.6043C10.2704 12.7804 10.1276 12.9232 9.95162 12.9232Z"
        fill="url(#paint37_linear_1284_8003)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1284_8003"
        x1="2.51569"
        y1="16.0952"
        x2="5.32743"
        y2="15.6829"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1284_8003"
        x1="3.27075"
        y1="24.3345"
        x2="3.98309"
        y2="25.4218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1284_8003"
        x1="3.71869"
        y1="6.63936"
        x2="6.2305"
        y2="9.52607"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1284_8003"
        x1="5.82916"
        y1="8.94176"
        x2="1.8552"
        y2="7.55465"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" stopOpacity="0" />
        <stop offset="0.2503" stopColor="#FF813A" stopOpacity="0.25" />
        <stop offset="0.7194" stopColor="#FF9A2B" stopOpacity="0.719" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1284_8003"
        x1="29.4828"
        y1="16.0952"
        x2="26.671"
        y2="15.6829"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1284_8003"
        x1="28.3717"
        y1="17.9145"
        x2="23.6855"
        y2="14.6903"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" stopOpacity="0" />
        <stop offset="0.5194" stopColor="#D9874F" stopOpacity="0.519" />
        <stop offset="1" stopColor="#B53759" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1284_8003"
        x1="28.7282"
        y1="24.3345"
        x2="28.0158"
        y2="25.4218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1284_8003"
        x1="28.2831"
        y1="6.63936"
        x2="25.7713"
        y2="9.52607"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1284_8003"
        x1="24.9139"
        y1="9.229"
        x2="19.8152"
        y2="4.69271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" stopOpacity="0" />
        <stop offset="0.2503" stopColor="#FF813A" stopOpacity="0.25" />
        <stop offset="0.7194" stopColor="#FF9A2B" stopOpacity="0.719" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1284_8003"
        x1="29.4487"
        y1="14.0395"
        x2="22.7005"
        y2="9.31572"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F92814" stopOpacity="0" />
        <stop offset="0.0664" stopColor="#F32817" stopOpacity="0.066" />
        <stop offset="0.4333" stopColor="#D82723" stopOpacity="0.433" />
        <stop offset="0.7567" stopColor="#C7272A" stopOpacity="0.757" />
        <stop offset="1" stopColor="#C1272D" />
      </linearGradient>
      <radialGradient
        id="paint10_radial_1284_8003"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.9998 3.73427) scale(3.2992)"
      >
        <stop stopColor="#FFA425" />
        <stop offset="0.2925" stopColor="#FFA727" />
        <stop offset="0.5496" stopColor="#FFB22D" />
        <stop offset="0.7925" stopColor="#FFC438" />
        <stop offset="1" stopColor="#FFDA45" />
      </radialGradient>
      <linearGradient
        id="paint11_linear_1284_8003"
        x1="6.77701"
        y1="10.0287"
        x2="28.2213"
        y2="32.5228"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18CFFC" />
        <stop offset="1" stopColor="#4A98F7" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1284_8003"
        x1="20.9729"
        y1="23.6157"
        x2="1.7779"
        y2="7.64483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18CFFC" stopOpacity="0" />
        <stop offset="1" stopColor="#65E1DC" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1284_8003"
        x1="15.8692"
        y1="19.8037"
        x2="39.1494"
        y2="14.068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0469BC" stopOpacity="0" />
        <stop offset="1" stopColor="#0469BC" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1284_8003"
        x1="20.6265"
        y1="32.8525"
        x2="15.1779"
        y2="20.6056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0469BC" stopOpacity="0" />
        <stop offset="1" stopColor="#0469BC" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1284_8003"
        x1="16.001"
        y1="29.6204"
        x2="16.001"
        y2="32.1741"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0469BC" stopOpacity="0" />
        <stop offset="1" stopColor="#0469BC" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1284_8003"
        x1="9.22132"
        y1="28.298"
        x2="6.59701"
        y2="24.9739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0469BC" stopOpacity="0" />
        <stop offset="1" stopColor="#0469BC" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1284_8003"
        x1="12.9778"
        y1="18.7724"
        x2="20.3258"
        y2="30.6193"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1284_8003"
        x1="12.2598"
        y1="23.4637"
        x2="40.0775"
        y2="24.8883"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" stopOpacity="0" />
        <stop offset="0.5194" stopColor="#D9874F" stopOpacity="0.519" />
        <stop offset="1" stopColor="#B53759" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1284_8003"
        x1="17.0735"
        y1="24.9743"
        x2="10.6252"
        y2="15.8767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" stopOpacity="0" />
        <stop offset="0.6245" stopColor="#FDE82B" stopOpacity="0.625" />
        <stop offset="1" stopColor="#FCEE21" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1284_8003"
        x1="15.9886"
        y1="23.7819"
        x2="16.0654"
        y2="21.6059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1284_8003"
        x1="16.7045"
        y1="22.547"
        x2="16.7045"
        y2="23.0219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1284_8003"
        x1="9.82937"
        y1="28.2582"
        x2="1.90647"
        y2="22.1348"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" stopOpacity="0" />
        <stop offset="0.5194" stopColor="#D9874F" stopOpacity="0.519" />
        <stop offset="1" stopColor="#B53759" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1284_8003"
        x1="5.19867"
        y1="24.5416"
        x2="7.99798"
        y2="26.3411"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <radialGradient
        id="paint24_radial_1284_8003"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.85051 24.0871) scale(0.962322)"
      >
        <stop stopColor="#C1272D" />
        <stop offset="0.2642" stopColor="#C5272B" stopOpacity="0.736" />
        <stop offset="0.5348" stopColor="#D12726" stopOpacity="0.465" />
        <stop offset="0.8073" stopColor="#E6281D" stopOpacity="0.193" />
        <stop offset="1" stopColor="#F92814" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint25_linear_1284_8003"
        x1="5.53516"
        y1="23.2277"
        x2="6.17271"
        y2="23.2277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1284_8003"
        x1="17.129"
        y1="16.1281"
        x2="12.4802"
        y2="3.90627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18CFFC" />
        <stop offset="1" stopColor="#4A98F7" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1284_8003"
        x1="15.8802"
        y1="11.6766"
        x2="16.1802"
        y2="15.4256"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18CFFC" />
        <stop offset="1" stopColor="#4A98F7" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_1284_8003"
        x1="15.9991"
        y1="12.375"
        x2="15.9991"
        y2="10.9504"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18CFFC" />
        <stop offset="1" stopColor="#4A98F7" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_1284_8003"
        x1="13.5229"
        y1="11.763"
        x2="13.5202"
        y2="12.1025"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_1284_8003"
        x1="10.8976"
        y1="11.7924"
        x2="10.8948"
        y2="12.1399"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_1284_8003"
        x1="16.1477"
        y1="11.766"
        x2="16.1451"
        y2="12.0982"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_1284_8003"
        x1="18.7723"
        y1="11.7924"
        x2="18.7696"
        y2="12.1286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_1284_8003"
        x1="21.3933"
        y1="11.8488"
        x2="21.3905"
        y2="12.1925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA45" />
        <stop offset="1" stopColor="#FFA425" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_1284_8003"
        x1="13.7832"
        y1="17.4705"
        x2="6.71003"
        y2="12.1718"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0469BC" stopOpacity="0" />
        <stop offset="1" stopColor="#0469BC" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_1284_8003"
        x1="9.29242"
        y1="13.619"
        x2="12.0917"
        y2="15.4185"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <radialGradient
        id="paint36_radial_1284_8003"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.95207 13.1642) scale(0.962318)"
      >
        <stop stopColor="#C1272D" />
        <stop offset="0.2642" stopColor="#C5272B" stopOpacity="0.736" />
        <stop offset="0.5348" stopColor="#D12726" stopOpacity="0.465" />
        <stop offset="0.8073" stopColor="#E6281D" stopOpacity="0.193" />
        <stop offset="1" stopColor="#F92814" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint37_linear_1284_8003"
        x1="9.63281"
        y1="12.3051"
        x2="10.2704"
        y2="12.3051"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7044" />
        <stop offset="1" stopColor="#F92814" />
      </linearGradient>
      <clipPath id="clip0_1284_8003">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconSchoolBag;
